import { render } from "./MainNavigation.vue?vue&type=template&id=deef609a&scoped=true&ts=true"
import script from "./MainNavigation.vue?vue&type=script&lang=ts"
export * from "./MainNavigation.vue?vue&type=script&lang=ts"

import "./MainNavigation.vue?vue&type=style&index=0&id=deef609a&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\HESEL\\DCS\\Client\\vuejs-dcs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-deef609a"]])

export default __exports__